// jQuery utility
// Ensures we use the global jQuery instance from script tag
// This instance has ParsleyJS and DataTables attached

let $;
if (typeof window !== 'undefined' && window.jQuery) {
    // Use the global jQuery that has ParsleyJS and DataTables attached
    $ = window.jQuery;
} else {
    // Fallback to webpack-imported jQuery if global isn't available
    const jQueryModule = require('jquery');
    $ = jQueryModule.default || jQueryModule;
    // Make it available globally
    if (typeof window !== 'undefined') {
        window.jQuery = window.$ = $;
    }
}

export default $;
